import React from 'react';
import { Tag, KIND, VARIANT } from 'baseui/tag';

interface ServiceChipProps {
	name: string;
}

const ServiceChip: React.FC<ServiceChipProps> = ({ name }) => {
	return (
		<Tag closeable={false} kind={KIND.primary} variant={VARIANT.outlined}>
			{name}
		</Tag>
	);
};

export default ServiceChip;
